var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 45.2625V18.75C90 16.7609 89.2098 14.8532 87.8033 13.4467C86.3968 12.0402 84.4891 11.25 82.5 11.25H37.5C35.5109 11.25 33.6032 12.0402 32.1967 13.4467C30.7902 14.8532 30 16.7609 30 18.75V45.2625L60 65.925L90 45.2625ZM45 26.25H75C75.9946 26.25 76.9484 26.6451 77.6516 27.3484C78.3549 28.0516 78.75 29.0054 78.75 30C78.75 30.9946 78.3549 31.9484 77.6516 32.6516C76.9484 33.3549 75.9946 33.75 75 33.75H45C44.0054 33.75 43.0516 33.3549 42.3483 32.6516C41.6451 31.9484 41.25 30.9946 41.25 30C41.25 29.0054 41.6451 28.0516 42.3483 27.3484C43.0516 26.6451 44.0054 26.25 45 26.25ZM41.25 45C41.25 44.0054 41.6451 43.0516 42.3483 42.3484C43.0516 41.6451 44.0054 41.25 45 41.25H75C75.9946 41.25 76.9484 41.6451 77.6516 42.3484C78.3549 43.0516 78.75 44.0054 78.75 45C78.75 45.9946 78.3549 46.9484 77.6516 47.6516C76.9484 48.3549 75.9946 48.75 75 48.75H45C44.0054 48.75 43.0516 48.3549 42.3483 47.6516C41.6451 46.9484 41.25 45.9946 41.25 45ZM112.5 41.25V101.25C112.5 104.234 111.315 107.095 109.205 109.205C107.095 111.315 104.234 112.5 101.25 112.5H18.75C15.7663 112.5 12.9048 111.315 10.795 109.205C8.68526 107.095 7.49999 104.234 7.49999 101.25V41.475C7.4454 41.1397 7.4454 40.7978 7.49999 40.4625C7.60106 39.9726 7.79911 39.5079 8.08248 39.0958C8.36585 38.6836 8.72881 38.3323 9.14999 38.0625L26.25 27.525V36.45H25.9875L17.9625 41.55L26.25 47.175L33.75 52.5L57.9 69.1125C58.5277 69.548 59.2735 69.7813 60.0375 69.7813C60.8015 69.7813 61.5473 69.548 62.175 69.1125L86.25 52.5L93.75 47.3625L102.037 41.6625L93.75 36.4125V27.6L110.7 38.0625C111.247 38.3957 111.7 38.8637 112.015 39.4217C112.33 39.9797 112.497 40.6092 112.5 41.25Z",
    fill: "url(#paint0_linear_340_1991)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_1991",
    x1: 7.45905,
    y1: 11.25,
    x2: 113.539,
    y2: 12.3505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B93FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.60a6043a3960bb83597a45d5de3b5cc3.svg";
export { ForwardRef as ReactComponent };